import React, { useState } from "react";
import Sidebar from "./Sidebar";
import { VscThreeBars } from "react-icons/vsc";
import NavigationBar from "./NavigationBar";
import Logo from "../../Assets/logo.png";
import classes from "./MainHeader.module.css";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const MainHeader = () => {
  const location = useLocation();

  const [showSideBar, setShowSideBar] = useState(false); //defining a state showSideBar and setting it as false

  const offsetY = useSelector((state) => state.browserData.browserHeight);
  const showSideBarHandler = () => {
    //defining a function for showing/hiding sideBar
    setShowSideBar((prev) => !prev); //setting the value of sidebar as oppisite of its previous
  };

  return (
    <header
      className={`${classes["main-header-container"]} ${
        offsetY > 60 ? classes["main-header-container-hide"] : ""
      }  `}
    >
      <div>
        <Sidebar showSideBar={showSideBar} onShowSideBar={showSideBarHandler} />
        <Link to="./">
          <img
            src={Logo}
            alt="logo"
            className={classes["main-header-container__logo"]}
          />
        </Link>
      </div>
      {/*checking value of offsetY and adding a css class*/}
      <div className={classes["main-header-container__icons"]}>
        {!showSideBar ? (
          <span className={`${classes["main-header-container__bars"]}`}>
            <VscThreeBars
              onClick={showSideBarHandler}
              className={
                location.pathname !== "/"
                  ? classes["main-header-container__bars-black"]
                  : ""
              }
            />
            {/* showing sidebar on click*/}
          </span>
        ) : (
          ""
        )}
      </div>
      <NavigationBar />
    </header>
  );
};

export default MainHeader;
